exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".toast---kgiAS {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  visibility: visible;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  opacity: 0;\n  -webkit-animation: fadeIn---2PfM_ 7s;\n          animation: fadeIn---2PfM_ 7s;\n  font-size: 17px;\n  z-index: 2147483647; }\n  .toastContent---1l5Gr {\n    padding: 15px;\n    width: 100%; }\n  .message---ryA0O {\n  color: white; }\n  @-webkit-keyframes fadeIn---2PfM_ {\n  0% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n  @keyframes fadeIn---2PfM_ {\n  0% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n  @media print {\n  .empty---m-1l8 {\n    display: none !important;\n    height: 0.001px !important; } }\n", ""]);

// exports
exports.locals = {
	"toast": "toast---kgiAS",
	"fadeIn": "fadeIn---2PfM_",
	"toastContent": "toastContent---1l5Gr",
	"message": "message---ryA0O",
	"empty": "empty---m-1l8"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/toast/index.scss
// module id = 3gQ+
// module chunks = 1